/*
 * File: CompanySelect.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 01 Dec 2021 1:52:14 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { Select } from 'antd';
import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ReduxState } from 'redux/rootReducer';
import { setSelectedCompanyDataAreaId } from 'redux/salesOrder/ordersSlice';
import { useGetLegalEntitiesQuery } from 'redux/services/useMaggieCadabbyService';

export const CompanySelect = (): JSX.Element => {
  const { selectedCompanyDataAreaId } = useSelector((state: ReduxState) => state.salesOrders);
  const { acuityContext } = useSelector((state: ReduxState) => state.app);

  const [selectedCompany, _setSelectedCompany] = useState<string | undefined>(undefined);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const { data, isLoading, isFetching } = useGetLegalEntitiesQuery(undefined);

  const handleSelect = (value: string): void => {
    _setSelectedCompany(value);
    dispatch(setSelectedCompanyDataAreaId(value));
    if (process.env.REACT_APP_COOKIE_PREFIX === 'localdev') {
      Cookies.set(`legalEntity`, value, { expires: 365 });
    } else {
      Cookies.set(`legalEntity`, value, { expires: 365, domain: 'mdsiinc.com' });
    }
    navigate('/');
  };

  const optionsJSX = data?.data.map((company) => (
    <Select.Option key={company.dataAreaId} value={company.dataAreaId}>
      {company.dataAreaId}
    </Select.Option>
  ));

  useEffect(() => {
    if (!selectedCompanyDataAreaId && !isLoading && !isFetching && data !== undefined && data.data.length && selectedCompany === undefined) {
      if (acuityContext?.selectedCustomer?.business) {
        dispatch(setSelectedCompanyDataAreaId(acuityContext.selectedCustomer.business.dataAreaId));
        _setSelectedCompany(acuityContext.selectedCustomer.business.dataAreaId);
      } else {
        dispatch(setSelectedCompanyDataAreaId(data.data[0].dataAreaId));
        _setSelectedCompany(data.data[0].dataAreaId);
      }
    }
  }, [acuityContext, data, dispatch, isFetching, isLoading, selectedCompany, selectedCompanyDataAreaId]);

  return (
    <Select onSelect={handleSelect} placeholder="Company" loading={isLoading || isFetching} defaultValue={selectedCompanyDataAreaId ?? undefined} value={selectedCompanyDataAreaId ?? undefined}>
      {optionsJSX}
    </Select>
  );
};
